import React, { createContext, PropsWithChildren, useContext, useMemo } from "react"

export interface QuizActions {
  answerQuestion(submission?: Quiz.Api.AnswerQuestionReq["submission"], wasTimeout?: boolean): void
  cancelQuiz(): void
  startQuiz(): void
  startQuestionCountdown(): void
  continueQuiz(): void
  enterRanking(userToken: string): void
}

export interface IQuizContext {
  quiz?: Quiz.Api.Quiz
  busy: boolean
  actions: QuizActions
}

export const QuizContext = createContext<IQuizContext>({
  busy: false,
  actions: {
    answerQuestion: () => {},
    startQuiz: () => {},
    startQuestionCountdown: () => {},
    cancelQuiz: () => {},
    continueQuiz: () => {},
    enterRanking: () => {},
  }
})
QuizContext.displayName = "QuizContext"

export const useQuiz = () => useContext(QuizContext)

export const WithQuiz: React.FC<React.PropsWithChildren<{quiz?: Quiz.Api.Quiz, busy: boolean, actions: QuizActions}>> = ({quiz, actions, busy, children}) => {
  return (
    <QuizContext.Provider value={{quiz, busy, actions}}>
      {children}
    </QuizContext.Provider>
  )
}

const getUniqueMountId = (() => {
  let _mountId = 0
  return () => {
    _mountId++
    return _mountId
  }
})()

export const MountIdContext = createContext({ mountId: 0 })

export const WithMountId: React.FC<PropsWithChildren> = ({ children }) => {
  const mountId = useMemo(getUniqueMountId, [])

  return <MountIdContext.Provider value={{ mountId }}>{children}</MountIdContext.Provider>
}
